// Geokoder adresów (Nominatim / OpenStreetMap) na potrzeby sekcji "Dane inwestycji".
// Zwraca współrzędne ORAZ rozbity adres — pinezka jest jednak niezależna: po wybraniu
// sugestii operator może przeciągnąć pin w inne miejsce niż podpowiedział resolver.

export interface GeocodedAddress {
  street: string
  buildingNumber: string
  postalCode: string
  city: string
  voivodeship: string
  county: string
  commune: string
}

export interface GeocodeResult {
  label: string // pełny adres do wyświetlenia na liście podpowiedzi
  lat: number
  lng: number
  address: GeocodedAddress
}

export async function searchGeocode(query: string): Promise<GeocodeResult[]> {
  if (query.trim().length < 3) return []

  const url =
    `https://nominatim.openstreetmap.org/search?` +
    `q=${encodeURIComponent(query)}&countrycodes=pl&format=json&addressdetails=1&limit=5`

  const res = await fetch(url, {
    headers: { 'Accept-Language': 'pl' },
  })
  if (!res.ok) return []

  const data = (await res.json()) as Array<{
    lat: string
    lon: string
    display_name: string
    address?: Record<string, string>
  }>

  return data.map((item) => {
    const a = item.address ?? {}
    return {
      label: item.display_name,
      lat: Number(item.lat),
      lng: Number(item.lon),
      address: {
        street: a.road ?? '',
        buildingNumber: a.house_number ?? '',
        postalCode: a.postcode ?? '',
        city: a.city ?? a.town ?? a.village ?? a.municipality ?? '',
        voivodeship: a.state ?? '',
        county: a.county ?? '',
        commune: a.municipality ?? '',
      },
    }
  })
}
